var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill",class:{'selected': _vm.selected, 'deletable': _vm.showDelete}},[_c('span',{staticClass:"pillcontent"},[_vm._v(_vm._s(_vm.value))]),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onRemove}},[(_vm.showDelete)?_c('font-awesome-icon',{attrs:{"icon":"times"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }